import { render } from "./App.vue?vue&type=template&id=6bcabeef"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6bcabeef&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/WaterQualityFrontEnd_Vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__